<template>
  <span
    class="inline-flex items-center justify-center bg-primary rounded-lg"
    style="width: 40px; height: 40px;"
  >
    <img
      src="/logoshield.webp"
      alt="CLG Signer"
      style="width: 72%; height: 72%; object-fit: contain;"
    >
  </span>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
